import React, { useState } from 'react';
import { Container, Image} from 'react-bootstrap';
import useIntersectionObserver from '../hooks/useIntersectionObserver';


const Terminos = () => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useIntersectionObserver(setIsVisible);

    return (
        <div>
            <div className='headermodule'>
                <Image src="/images/banner_vml.jpg" fluid />
            </div>
            <Container ref={ref} className={`paddcontainer opacitycontainer ${isVisible ? 'fade-in' : ''}`}>
                <h1>Términos y condiciones</h1>
                <p>Al participar en VML Academy, los(as) participantes aceptan que todo el contenido presentado durante las clases es confidencial y constituye propiedad exclusiva de VML. Asimismo, cualquier idea, proyecto o trabajo creativo desarrollado en el marco del programa será considerado propiedad intelectual de la agencia. Los(as) participantes se comprometen a no utilizar, divulgar ni reproducir dicho contenido sin la autorización previa y por escrito de VML.</p>
                <p>Como requisito para participar en el programa, los(as) postulantes no deben estar empleados(as) en ninguna agencia de publicidad o alguna empresa que sea competidora directa de los clientes de VML Perú al momento de su inscripción ni durante la duración del programa. En caso de surgir una oportunidad laboral en este ámbito mientras el/la participante forma parte del programa, deberá notificarlo inmediatamente a VML para evaluar la situación y determinar los pasos a seguir.</p>
                <p>La inscripción en VML Academy implica la aceptación plena de estos términos y condiciones.</p>
            </Container>
        </div>
    );
};

export default Terminos;
